export default __webpack_public_path__ + "static/the-block-308-8482b69bf5ae8613204d0df73a89e220.png";